import { Injectable } from '@angular/core';
import { EntityType } from '@app/shared/enums/entity-type.enum';
import { ApiService } from './api.service';

@Injectable()
export class PlataformasService extends ApiService {
  entityType = EntityType.PLATAFORMA;
  url = 'api/plataformas/';
}
